import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { get } from 'lodash'
import PageHeader from '../../elements/PageHeader'
import {
  resetActiveCabins,
  resetActiveEmailConfiguration,
  resetActiveFilters,
  resetActivePackages
} from '../../../actions/resetQuoteFlow'
import setActiveStep, {
  setPreviousStep
} from '../../../actions/setActiveStepActions'
import updateSearchParams from '../../../utilities/updateSearchParams'
import resetUrlToHome from '../../../utilities/resetUrlToHome'
import { multipleCurrenciesAvailable } from '../../../reducers/fetchSsoReducers'
import {
  setActiveVoyageType,
  setActiveBrand,
  setActiveEndDate,
  setActiveRegion,
  setActiveStartDate,
  updateCurrency
} from '../../../actions/setActiveSearchFilters'
import {
  setActivePriceTableVoyageTypeFilter,
  setActivePriceTableCurrencyFilter,
  setActivePriceTableDestinationFilter,
  setActivePriceTableCategoryFilter,
  setActivePriceTableBrandFilter
} from '../../../actions/setActivePriceTableSearchFilters'

import fetchDestinationMonths from '../../../actions/fetchDestinationMonths'
import EQuoteSearchFilterPriceSelect from './EQuoteSearchFilterPriceSelect'
import '../../../styles/scss/base/tables.scss'
import '../../../styles/scss/components/equote-sailings-full-search.scss'
import '../../../styles/scss/components/equote-destination-price-search.scss'
import fetchPackages from '../../../actions/fetchPackages'
import EQuoteSearchPriceTable from './EquoteSearchPriceTable'
import triggerCustomGaEvent from '../../../utilities/triggerCustomGaEvent'
import ArrowLeft from '../../../assets/icons/arrow-left.svg'
import ArrowRight from '../../../assets/icons/arrow-right.svg'
import syncHeaderBody from '../../../utilities/syncHeaderBody'
import { getBrandsData } from '../../../sessionStorage/getBrandsData'
import { getDestinationsData } from '../../../sessionStorage/getDestinationsData'
import { getLabelsData } from '../../../sessionStorage/getLabelsData'
import { formatTerms } from '../../../utilities/formatTerms'
import { ACTIVE_BRANDS } from '../../../configuration/brands'
import GeneralTermsAndConditions from '../../../components/terms/GeneralTermsAndConditions'

import {
  PRICE_VOYAGE_OPTIONS,
  PRICE_ALL_VOYAGE_OPTIONS,
  RIVER_SHIP_CODES
} from '../../../configuration/filters'

const tableCellHeight = '87px'
const destinationCellWidth = '200px'
const headerHeight = '56px'

function toggleRightFade(tableScrollContainer) {
  const container = document.getElementById(
    'equote__sailings-search-price-table-container'
  )
  const rightArrow = document.querySelector(
    '#equote__sailings-search-price-table-container .scroll-right'
  )
  const leftArrow = document.querySelector(
    '#equote__sailings-search-price-table-container .scroll-left'
  )

  if (tableScrollContainer.scrollLeft <= 0) {
    leftArrow && leftArrow.classList.add('u-element-hidden')
  } else {
    leftArrow && leftArrow.classList.remove('u-element-hidden')
  }

  if (
    tableScrollContainer.scrollLeft + tableScrollContainer.clientWidth <
    tableScrollContainer.scrollWidth
  ) {
    container && container.classList.add('show-fade')
    rightArrow && rightArrow.classList.remove('u-element-hidden')
  } else {
    container && container.classList.remove('show-fade')
    rightArrow && rightArrow.classList.add('u-element-hidden')
  }
}

class EQuoteSearchPriceTableContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.wrapperRef = createRef()
    this.searchPriceTable = createRef()
  }

  scrollTable = direction => {
    const tableContainer = document.getElementById(
      'equote__search-price-table-container'
    )
    const tableScrollContainer = tableContainer.getElementsByTagName('div')[2]
    const table = tableScrollContainer?.getElementsByTagName('table')[0]
    const offSet = tableScrollContainer?.getBoundingClientRect().left
    const left = table?.getBoundingClientRect().left
    const widthPerCell = table
      .querySelectorAll('.u-table-price-cell:not(.u-element-remove)')[0]
      ?.getBoundingClientRect().width
    const newLeft =
      direction === 'right'
        ? widthPerCell * 2 + offSet - left
        : offSet - left - widthPerCell * 2
    this.lastPositionLeft = newLeft
    tableScrollContainer.scrollTo({ left: newLeft, behavior: 'smooth' })
  }

  updateScrollPosition = e => {
    this.lastPositionLeft = e.currentTarget.scrollLeft
  }

  onScrollHorizontallyRepaintDestinationHeader = () => {
    if (this.searchPriceTable.current) {
      let destinationHeader = this.searchPriceTable.current.querySelector(
        '.equote__search-price-table-fixed-destination-header'
      )
      let table = this.searchPriceTable.current.querySelector(
        '#equote__search-price-table-container'
      )
      destinationHeader.style.left = table.getBoundingClientRect().left + 'px'
    }
  }

  onScrollRepaintHead = () => {
    let resultTable = this.searchPriceTable.current.querySelector('table')
    let headerTable = resultTable && resultTable.querySelector('thead')
    let mockHeader = this.searchPriceTable.current.querySelector(
      '.equote__search-price-table-mock-destination-header'
    )

    let newHeader = mockHeader.querySelector('thead')
    let table = this.searchPriceTable.current.querySelector(
      '#equote__search-price-table-container'
    )
    let body = this.searchPriceTable.current.querySelector(
      '#equote__search-price-table-container > div > div > div'
    )
    let destinationHeader = this.searchPriceTable.current.querySelector(
      '.equote__search-price-table-fixed-destination-header'
    )
    if (this.wrapperRef.current.offsetTop + 56 <= window.scrollY) {
      if (!newHeader) {
        destinationHeader.style.display = 'block'
        destinationHeader.style.position = 'fixed'
        destinationHeader.style.left = table.getBoundingClientRect().left + 'px'
        newHeader = headerTable.cloneNode(true)
        headerTable.style.visibility = 'collapse'
        newHeader.classList.add('u-position-sticky')
        mockHeader.classList.add('syncscroll')
        mockHeader.setAttribute('name', 'headersync')
        mockHeader.classList.toggle('u-position-sticky')
        mockHeader.prepend(newHeader)
        mockHeader.style.width = '100%'
        body.classList.add('syncscroll')
        body.setAttribute('name', 'headersync')
        syncHeaderBody()

        if (this.lastPositionLeft) {
          body.scrollTo({ left: this.lastPositionLeft })
          mockHeader.scrollTo({
            left: this.lastPositionLeft
          })
        }
      }
    } else {
      destinationHeader.style.display = 'none'
      newHeader && mockHeader.removeChild(newHeader)
      mockHeader.style.width = '100px'
      mockHeader.classList.remove('u-position-sticky')
      headerTable.style.visibility = 'visible'

      if (window.innerWidth < 480) {
        mockHeader.style.width = '120px'
      } else {
        mockHeader.style.width = '200px'
      }
    }

    if (
      this.wrapperRef.current.offsetTop +
        this.wrapperRef.current.clientHeight -
        56 <=
      window.scrollY
    ) {
      mockHeader.style.display = 'none'
    } else {
      mockHeader.style.display = 'block'
    }
  }

  componentDidMount() {
    triggerCustomGaEvent('equoteSearch-price', {
      ...this.props.activeSearchFilterData,
      ...this.props.loyaltyData
    })
    let body = document.querySelector(
      '#equote__search-price-table-container > div > div > div'
    )
    body.addEventListener('scroll', this.updateScrollPosition)
    window.addEventListener('scroll', this.onScrollRepaintHead)
    window.addEventListener(
      'resize',
      this.onScrollHorizontallyRepaintDestinationHeader
    )

    const tableContainer = this.searchPriceTable.current.querySelector(
      '#equote__search-price-table-container'
    )

    const tableScrollContainer = tableContainer.getElementsByTagName('div')[2]
    if (tableContainer && tableScrollContainer) {
      if (tableScrollContainer) {
        tableScrollContainer.addEventListener('scroll', () => {
          toggleRightFade(tableScrollContainer)
        })

        toggleRightFade(tableScrollContainer)
      } else {
        document
          .getElementById('equote__sailings-search-price-table-container')
          .classList.remove('show-fade')
      }
    }
  }

  componentDidUpdate() {
    const tableContainer = this.searchPriceTable.current.querySelector(
      '#equote__search-price-table-container'
    )

    const tableScrollContainer = tableContainer.getElementsByTagName('div')[2]

    window.addEventListener('scroll', this.onScrollRepaintHead)
    tableScrollContainer.addEventListener('scroll', () => {
      toggleRightFade(tableScrollContainer)
    })
  }

  componentWillUnmount() {
    window.removeEventListener(
      'resize',
      this.onScrollHorizontallyRepaintDestinationHeader
    )
    let body = document.querySelector(
      '#equote__search-price-table-container > div > div > div'
    )
    window.removeEventListener('scroll', this.onScrollRepaintHead)
    body.removeEventListener('scroll', this.updateScrollPosition)

    const tableContainer = document.getElementById(
      'equote__search-price-table-container'
    )
    const tableScrollContainer = tableContainer.getElementsByTagName('div')[2]
    if (tableScrollContainer) {
      tableScrollContainer.removeEventListener('scroll', () =>
        toggleRightFade()
      )
    }
  }

  renderDisclaimer() {
    const { activeSearchByPriceTableFilters, brands } = this.props
    let disclaimer
    if (
      activeSearchByPriceTableFilters.brand === 'Z' ||
      activeSearchByPriceTableFilters.brand === 'R' ||
      activeSearchByPriceTableFilters.brand === 'C'
    ) {
      const currentBrand =
        brands &&
        brands.find(
          brand => brand.brand_code === activeSearchByPriceTableFilters.brand
        )
      disclaimer =
        currentBrand && currentBrand.disclaimer_pricing
          ? currentBrand.disclaimer_pricing
          : null
    } else {
      const currentBrand =
        brands && brands.find(brand => brand.brand_code === 'D')

      disclaimer =
        currentBrand && currentBrand.disclaimer_pricing
          ? currentBrand.disclaimer_pricing
          : null
    }

    if (activeSearchByPriceTableFilters.currency !== 'USD') {
      return disclaimer.replace(
        /USD/gi,
        activeSearchByPriceTableFilters.currency
      )
    }

    if (activeSearchByPriceTableFilters.currency === 'USD') {
      return formatTerms(disclaimer)
    }

    if (disclaimer.charAt(0) !== '*') {
      disclaimer = '* ' + disclaimer
    }

    return disclaimer
  }

  handlePriceSelection(pricingInfo) {
    const {
      activeSearchFilterData,
      handleActiveVoyageType,
      handleActiveBrand,
      handleActiveDestination,
      handleActiveStartDate,
      handleActiveEndDate,
      handleSubmitQueryPackages,
      selectedVoyageType,
      selectedBrand,
      selectedCurrency,
      ssoData
    } = this.props

    const { destination, month } = pricingInfo

    const momentStartDate = moment(month, 'YYYY_MM')
    const startDate = momentStartDate.isSame(moment(), 'month')
      ? moment().format('YYYY-MM-DD')
      : momentStartDate
          .clone()
          .startOf('month')
          .format('YYYY-MM-DD')

    const endDate = momentStartDate
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')
    const destinationQuery = {
      voyageType:
        activeSearchFilterData.selectedVoyageType || selectedVoyageType,
      brand: selectedBrand,
      bookingType: activeSearchFilterData.bookingType,
      endDate,
      cruiseType: activeSearchFilterData.cruiseType,
      currency: selectedCurrency,
      startDate: startDate,
      region: destination,
      sso: activeSearchFilterData.sso
    }

    handleActiveVoyageType(selectedVoyageType)
    handleActiveBrand(selectedBrand)
    handleActiveDestination(destination)
    handleActiveStartDate(startDate)
    handleActiveEndDate(endDate)
    updateSearchParams(destinationQuery)
    handleSubmitQueryPackages(ssoData)

    triggerCustomGaEvent('price-table-selection', { ...destinationQuery })
  }

  handleDestinationSelection(destination) {
    const {
      activeSearchFilterData,
      handleActiveBrand,
      handleActiveDestination,
      handleActiveStartDate,
      handleSubmitQueryPackages,
      selectedVoyageType,
      selectedCurrency,
      selectedBrand,
      ssoData
    } = this.props

    const startDate = moment().format('YYYY-MM-DD')
    const destinationQuery = {
      voyageType: selectedVoyageType,
      brand: selectedBrand,
      bookingType: activeSearchFilterData.bookingType,
      count: activeSearchFilterData.count,
      cruiseType: activeSearchFilterData.cruiseType,
      currency: selectedCurrency,
      startDate: startDate,
      region: destination,
      sso: activeSearchFilterData.sso
    }

    handleActiveBrand(selectedBrand)
    handleActiveDestination(destination)
    handleActiveStartDate(startDate)
    updateSearchParams(destinationQuery)
    handleSubmitQueryPackages(ssoData)
  }

  handleResetQuoteFlow = () => {
    triggerCustomGaEvent('equote-begin-new-search', {
      component: 'SearchPriceTableContainer'
    })
    const { activeSearchFilterData, resetQuoteFlow } = this.props

    resetQuoteFlow()
    resetUrlToHome(activeSearchFilterData.sso)
  }

  handleVoyageTypeSelection(e) {
    const selectedType = PRICE_ALL_VOYAGE_OPTIONS.find(
      item => item.value === e.target.value
    )

    if (selectedType.brands.length === 1) {
      this.props.setActivePriceTableBrandFilter(selectedType.brands[0])
    }

    this.props.setActivePriceTableVoyageTypeFilter(e.target.value)
  }

  renderVoyageSelect() {
    return (
      <EQuoteSearchFilterPriceSelect
        value={this.props.selectedVoyageType}
        onChange={event => {
          triggerCustomGaEvent('price-table-filter', {
            filter: 'voyageType',
            value: event.target.value
          })
          this.handleVoyageTypeSelection(event)
        }}
        defaultValue="O,V"
        defaultLabel="All Types"
        options={PRICE_VOYAGE_OPTIONS}
      />
    )
  }

  renderBrandSelect() {
    const { brands, selectedVoyageType } = this.props
    if (!brands) return null

    const selectedType = PRICE_ALL_VOYAGE_OPTIONS.find(
      item => item.value === selectedVoyageType
    )

    const options = brands.map(brand => {
      if (!ACTIVE_BRANDS.includes(brand.brand_code)) return null
      return {
        key: brand.brand_code,
        value: brand.brand_code,
        label: brand.name,
        disabled: !selectedType?.brands.includes(brand.brand_code) ?? false
      }
    })

    return (
      <EQuoteSearchFilterPriceSelect
        value={this.props.selectedBrand}
        onChange={event => {
          triggerCustomGaEvent('price-table-filter', {
            filter: 'brand',
            value: event.target.value
          })
          this.props.setActivePriceTableBrandFilter(event.target.value)
        }}
        defaultValue="C,R"
        defaultLabel="All Brands"
        defaultDisabled={selectedType?.brands?.length === 1 ?? false}
        options={options}
      />
    )
  }

  renderDestinationSelect() {
    const { destinations } = this.props
    const options = destinations.map(destination => {
      return {
        key: destination.destination_code,
        value: destination.destination_code,
        label: destination.name
      }
    })

    return (
      <EQuoteSearchFilterPriceSelect
        value={this.props.selectedDestination}
        onChange={event => {
          triggerCustomGaEvent('price-table-filter', {
            filter: 'destination',
            value: event.target.value
          })
          this.props.setActivePriceTableDestinationFilter(event.target.value)
        }}
        defaultValue="all"
        defaultLabel="Destinations"
        options={options}
      />
    )
  }

  renderCategorySelect() {
    const { selectedVoyageType } = this.props
    const oceanOptions = [
      {
        value: 'I',
        label: 'Interior'
      },
      {
        value: 'O',
        label: 'Oceanview'
      },
      {
        value: 'B',
        label: 'Balcony'
      },
      {
        value: 'D',
        label: 'Deluxe'
      }
    ]

    const riverOptions = [
      {
        value: 'O',
        label: 'River View'
      },
      {
        value: 'B',
        label: 'Balcony'
      },
      {
        value: 'D',
        label: 'Deluxe'
      }
    ]

    return (
      <EQuoteSearchFilterPriceSelect
        value={this.props.selectedCategory}
        onChange={event => {
          triggerCustomGaEvent('price-table-filter', {
            filter: 'category',
            value: event.target.value
          })
          this.props.setActivePriceTableCategoryFilter(event.target.value)
        }}
        defaultValue="bestUnfilteredRate"
        defaultLabel="Category"
        options={selectedVoyageType !== 'V' ? oceanOptions : riverOptions}
      />
    )
  }

  renderCurrencySelect() {
    if (!this.props.multipleCurrenciesAvailable) return null

    const { transactionData } = this.props
    const options = transactionData.paymentLevels.map(paymentOption => {
      return {
        key: paymentOption.paymentCurrencyCode,
        value: paymentOption.paymentCurrencyCode,
        label: paymentOption.paymentCurrencyCode
      }
    })
    return (
      <div className="equote__search-price-table--filters-row">
        <div className="equote__search-price-table--filters-row-group">
          <h4>Currency</h4>

          <EQuoteSearchFilterPriceSelect
            value={this.props.selectedCurrency}
            onChange={event => {
              triggerCustomGaEvent('price-table-filter', {
                filter: 'currency',
                value: event.target.value
              })
              this.props.updateCurrency(event.target.value)
            }}
            options={options}
          />
        </div>
      </div>
    )
  }

  renderMonthCell(pricingInfo) {
    const guestCount =
      this.props.activeSearchFilterData &&
      this.props.activeSearchFilterData.guestCount
        ? Number(this.props.activeSearchFilterData.guestCount)
        : 2

    if (!pricingInfo) {
      return (
        <div className="u-table-price-cell u-element-remove">
          <button className="price-info-button u-transparent">
            <span className="price-info-button--best-price">
              $
              <span className="price-info-button--best-price-value">
                {(0).toFixed(2)}
              </span>
            </span>
            <span className="equote__sailings-table-best-price-description u-font-uppercase" />
          </button>
        </div>
      )
    }
    return (
      <div
        onClick={() => this.handlePriceSelection(pricingInfo)}
        className="u-table-price-cell"
      >
        <button className="price-info-button u-transparent">
          <span className="price-info-button--best-price">
            $
            <span className="price-info-button--best-price-value">
              {(pricingInfo.netPrice / guestCount).toFixed(2)}
            </span>
          </span>
          <span className="equote__sailings-table-best-price-description u-font-uppercase">
            {pricingInfo.leadPromoDesc}
          </span>
        </button>
      </div>
    )
  }

  renderDestinationCell(destination) {
    return (
      <div className={`destination-cell`}>
        <button
          onClick={
            destination &&
            destination.destinationInfo &&
            destination.destinationInfo.destination_code
              ? () =>
                  this.handleDestinationSelection(
                    destination.destinationInfo.destination_code
                  )
              : null
          }
          className="destination-info-button u-transparent"
        >
          <span>
            {destination.destinationInfo && destination.destinationInfo.name
              ? destination.destinationInfo.name
              : null}
          </span>
        </button>
      </div>
    )
  }

  renderColumns() {
    const columns = [
      {
        title: 'Destination',
        field: 'destination',
        customSort: (a, b) => {
          const first =
            a &&
            a.destination &&
            a.destination.destinationInfo &&
            a.destination.destinationInfo.name
              ? a.destination.destinationInfo.name
              : 'a'
          const second =
            b &&
            b.destination &&
            b.destination.destinationInfo &&
            b.destination.destinationInfo.name
              ? b.destination.destinationInfo.name
              : 'a'
          return first < second ? -1 : 1
        },
        sorting: true,
        // defaultFilter: this.props.filterTerms.brand,
        render: rowData => {
          return rowData.destination
            ? this.renderDestinationCell(rowData.destination)
            : null
          // <span>
          //   {rowData.destination.destinationInfo
          //     ? rowData.destination.destinationInfo.name
          //     : null}
          // </span>
        },
        cellStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          margin: 'auto',
          minWidth: 200,
          maxWidth: 200,
          minHeight: tableCellHeight,
          position: 'sticky',
          left: 0,
          zIndex: 2
        },
        headerStyle: {
          minWidth: 200,
          maxWidth: 200,
          height: headerHeight,
          position: 'sticky',
          left: 0,
          zIndex: 3,
          backgroundColor: '#2a467b'
        }
      }
    ]

    if (this.props.availableMonths && this.props.availableMonths.length) {
      for (const month of this.props.availableMonths) {
        columns.push({
          title: moment(month, 'YYYY-MM').format('MMM | YYYY'),
          defaultSort: 'desc',
          customSort: (a, b) => {
            const aNetPrice =
              a[month] && a[month].netPrice ? a[month].netPrice : null
            const bNetPrice =
              b[month] && b[month].netPrice ? b[month].netPrice : null
            if (!aNetPrice && !bNetPrice) return 0
            if (aNetPrice && !bNetPrice) return -1
            if (bNetPrice && !aNetPrice) return 1

            return aNetPrice - bNetPrice
          },
          field: month,
          render: rowData => {
            if (!rowData[month]) return null
            return rowData[month] ? this.renderMonthCell(rowData[month]) : null
          },
          cellStyle: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            margin: 'auto',
            minWidth: 100,
            maxWidth: 100,
            height: tableCellHeight,
            zIndex: 2,
            textAlign: 'center'
          },
          headerStyle: {
            // minWidth: 200,
            // maxWidth: 200,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            minWidth: 100,
            maxWidth: 100,
            height: headerHeight,
            textAlign: 'center'
          }
        })
      }
    }
    return columns
  }

  renderData() {
    const {
      selectedVoyageType,
      selectedBrand,
      selectedDestination,
      selectedCategory,
      destinationMonthsData,
      destinations
    } = this.props

    const data = []
    const datesAvailable = {}

    if (destinationMonthsData && Object.keys(destinationMonthsData).length) {
      for (const [destinationKey, months] of Object.entries(
        destinationMonthsData
      )) {
        if (
          selectedDestination &&
          selectedDestination !== 'all' &&
          destinationKey !== selectedDestination
        ) {
          continue
        }

        const destinationData = {}
        let filtered = {}

        if (selectedVoyageType !== 'O,V') {
          for (const [monthKey, month] of Object.entries(months)) {
            // filter only ocean packages
            if (
              selectedVoyageType === 'O' &&
              !RIVER_SHIP_CODES.includes(month?.bestUnfilteredRate?.shipCode)
            ) {
              filtered[monthKey] = month
            }
            // filter only river packages
            if (
              selectedVoyageType === 'V' &&
              RIVER_SHIP_CODES.includes(month?.bestUnfilteredRate?.shipCode) &&
              month?.bestUnfilteredRate?.brand === 'C'
            ) {
              filtered[monthKey] = month
            }
          }
        } else {
          filtered = months
        }

        for (const [monthKey, month] of Object.entries(filtered)) {
          let pricing = null

          if (selectedBrand !== 'C,R') {
            if (month[selectedBrand]) {
              Object.entries(month[selectedBrand]).forEach(stateroom => {
                if (
                  selectedCategory !== 'bestUnfilteredRate' &&
                  stateroom[0] !== selectedCategory
                ) {
                  return
                }
                if (!pricing || pricing.netPrice > stateroom.netPrice) {
                  pricing = {
                    ...stateroom[1],
                    stateroomType: stateroom[0],
                    brand: selectedBrand,
                    month: monthKey,
                    destination: destinationKey
                  }
                }
              })
            }
          } else {
            pricing =
              selectedCategory === 'bestUnfilteredRate'
                ? month.bestUnfilteredRate
                : month.bestRateByCategory[selectedCategory]
          }

          destinationData[monthKey] = pricing
        }

        const destinationInfo = destinations.find(
          destination => destination.destination_code === destinationKey
        )

        data.push({
          destination: destinationInfo
            ? { destinationInfo, destinationKey }
            : {
                destinationInfo: {
                  name: destinationKey,
                  destination_code: destinationKey
                },
                destinationKey
              },
          ...destinationData
        })
      }
    }

    const results = data.map(date => {
      return { ...datesAvailable, ...date }
    })

    return results
  }

  render() {
    const tableColumns = this.renderColumns()
    const data = this.renderData()
    const currencyCode = get(this, 'props.activeSearchFilterData.currency')
    const paymentLevels = get(this, 'props.transactionData.paymentLevels', [])
    const paymentCurrencyText = get(
      paymentLevels.find(level => level.paymentCurrencyCode === currencyCode),
      'paymentCurrencyText',
      ''
    ).toLowerCase()
    return (
      <div className="equote__search-price-table">
        <div className="u-content-container">
          <PageHeader
            title="Search and Compare Cruises by Price"
            subTitle={
              <>
                Prices shown are lowest available for the criteria selected.
                Prices are in{' '}
                <span className="u-capitalize">{paymentCurrencyText}</span>.
              </>
            }
            buttonText="BEGIN A NEW SEARCH"
            clickHandler={this.handleResetQuoteFlow}
          />
        </div>
        <div className="equote__search-price-table--filters">
          <div className="u-content-container">
            <div className="equote__search-price-table--filters-row">
              <h4>show prices based on</h4>
              <div className={'u-flex'}>
                {/* {this.renderVoyageSelect()} */}
                {this.renderBrandSelect()}
                {this.renderCategorySelect()}
                {this.renderDestinationSelect()}
              </div>
            </div>
            {this.renderCurrencySelect()}
          </div>
        </div>

        <div
          ref={this.wrapperRef}
          className="equote__sailings-search-price-table-wrapper"
        >
          <div
            id="equote__sailings-search-price-table-container"
            className={`u-content-container show-fade`}
          >
            <button
              className="btn scroll-left"
              onClick={() => this.scrollTable('left')}
            >
              <img src={ArrowLeft} alt="scroll left" />
            </button>

            <button
              className="btn scroll-right"
              onClick={() => this.scrollTable('right')}
            >
              <img src={ArrowRight} alt="scroll right" />
            </button>
            <EQuoteSearchPriceTable
              ref={this.searchPriceTable}
              tableColumns={tableColumns}
              headerHeight={headerHeight}
              destinationCellWidth={destinationCellWidth}
              data={data}
            />
          </div>
        </div>
        <div className="equote__search-price-table-disclaimer">
          <h5>Terms and Conditions</h5>
          <GeneralTermsAndConditions />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeSearchFilterData: state.activeSearchFilterData,
    currency: state.activeSearchFilterData
      ? state.activeSearchFilterData.currency === 'USD'
        ? 'US'
        : 'Canadian'
      : 'US',
    brands: getBrandsData(),
    destinations: getDestinationsData(),
    multipleCurrenciesAvailable: multipleCurrenciesAvailable(state),
    transactionData: state.ssoData.transactionData,
    labelsData: getLabelsData(),
    selectedVoyageType: state.activeSearchByPriceTableFilters.voyageType,
    selectedCurrency:
      state.activeSearchFilterData.currency ||
      state.activeSearchByPriceTableFilters.currency,
    selectedBrand: state.activeSearchByPriceTableFilters.brand,
    selectedDestination: state.activeSearchByPriceTableFilters.destination,
    selectedCategory: state.activeSearchByPriceTableFilters.category,
    activeSearchByPriceTableFilters: state.activeSearchByPriceTableFilters,
    loyaltyData: state.loyaltyData,
    ssoData: state.ssoData
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetQuoteFlow() {
      return (
        dispatch(resetActiveCabins()),
        dispatch(resetActivePackages()),
        dispatch(resetActiveFilters()),
        dispatch(resetActiveEmailConfiguration()),
        dispatch(setActiveStep(0)),
        dispatch(setPreviousStep(null))
      )
    },
    updateCurrency(currency) {
      dispatch(updateCurrency(currency))
      dispatch(setActivePriceTableCurrencyFilter(currency))
      dispatch(fetchDestinationMonths())
    },
    handleActiveVoyageType(type) {
      return dispatch(setActiveVoyageType(type))
    },
    handleActiveBrand(brand) {
      return dispatch(setActiveBrand(brand))
    },
    handleActiveDestination(destination) {
      return dispatch(setActiveRegion(destination))
    },
    handleActiveStartDate(startDate) {
      return dispatch(setActiveStartDate(startDate))
    },
    handleActiveEndDate(endDate) {
      return dispatch(setActiveEndDate(endDate))
    },
    handleSubmitQueryPackages(ssoData) {
      dispatch(setActiveStep(1))
      dispatch(setPreviousStep(5))
      return dispatch(fetchPackages(ssoData))
    },
    setActivePriceTableVoyageTypeFilter(type) {
      dispatch(setActivePriceTableVoyageTypeFilter(type))
    },
    setActivePriceTableDestinationFilter(destination) {
      dispatch(setActivePriceTableDestinationFilter(destination))
    },
    setActivePriceTableCategoryFilter(category) {
      dispatch(setActivePriceTableCategoryFilter(category))
    },
    setActivePriceTableBrandFilter(brand) {
      dispatch(setActivePriceTableBrandFilter(brand))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EQuoteSearchPriceTableContainer)
